import { MODULE_BLUEPRINTS } from "../blueprints";
import { MODULE_INSTANCES } from "../instances";
import { createModuleRegistry } from "./registry";
import type { ModuleInstance } from "./types";

export * from "./types";
export { createModuleRegistry } from "./registry";
export type { ModuleRegistry } from "./registry";

/** Uygulama genelinde kullanılan tek registry. */
export const moduleRegistry = createModuleRegistry({
  blueprints: MODULE_BLUEPRINTS,
  instances: MODULE_INSTANCES,
});

/** Instance'ın blueprint'i sohbet açmış mı (`chat.enabled`) ve hangi ajan. */
export const getModuleChatConfig = (instance: ModuleInstance | undefined) =>
  instance?.blueprint
    ? moduleRegistry.getBlueprint(instance.blueprint).chat
    : undefined;

/**
 * Boot'ta bir kez çözülen "host modülü": `shop.chatharmony.ai` gibi bir
 * subdomain'deysek o instance root'a (`""`) mount edilir ve yalnızca onun
 * route'ları + shared route'lar yaşar. Ana domainde `undefined`.
 */
export const hostModule: ModuleInstance | undefined =
  typeof window !== "undefined"
    ? moduleRegistry.getModuleByHost(window.location.hostname)
    : undefined;

/** Instance'ın bu host'ta mount edildiği prefix (`""` ya da `/fashion`). */
export const getModuleBasePath = (instance: ModuleInstance): string =>
  hostModule?.id === instance.id ? "" : instance.basePath;

/**
 * Subdomain'deysek ana domain origin'i (`shop.chatharmony.ai` → `https://chatharmony.ai`).
 * Host modülü dışındaki modüllere link üretmek için; bu host'ta o route'lar mount değil.
 */
const mainOrigin = (): string => {
  const { protocol, host } = window.location;
  const [, ...rest] = host.split(".");
  return `${protocol}//${rest.join(".")}`;
};

/**
 * Bir modül segmentine mutlak path üretir. Modül kodunda hiçbir yerde
 * `"/fashion/shop"` gibi literal yazılmaz; her zaman buradan geçer.
 *
 * Subdomain'de başka bir modüle link istenirse tam URL döner; `<Link>` ve
 * `navigate()` origin farkını görüp tam sayfa geçiş yapar.
 *
 * @example getModuleHref(fashion, "shop") → "/fashion/shop" (ana domain) | "/shop" (shop.*)
 * @example getModuleHref(fashion, "")     → "/fashion" | "/"
 * @example shop.* üzerinde getModuleHref(models, "library") → "https://chatharmony.ai/models/library"
 */
export const getModuleHref = (
  instance: ModuleInstance,
  segment = "",
): string => {
  const seg = segment.replace(/^\/+/, "");

  if (hostModule && hostModule.id !== instance.id) {
    const path = seg ? `${instance.basePath}/${seg}` : instance.basePath;
    return `${mainOrigin()}${path}`;
  }

  const base = getModuleBasePath(instance);
  const path = seg ? `${base}/${seg}` : base;
  return path || "/";
};
